import { UiActions } from '@app/store/actions';
import { isFunction, get } from 'lodash';

/**
 * use this to add ui loader wrap
 * caution: this need uiActions property in your class
 *
 * @param targetParamPos target params position in the method params list, default is 0
 * @param isPreventLoaderCloseAfterRequestFinish decide whether prevent loader auto close.
 * in some cases, when all api request finished, loader will be auto closed,
 * but we also have some calculate like generate pdf need keep loader,
 * so we need prevent loader auto close, just set this param isPreventLoaderCloseAfterRequestFinish as true.
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,
function wrapWithLoader(
  isEnableLoaderField: string,
  targetParamPos: number = 0,
  isPreventLoaderCloseAfterRequestFinish: boolean = false,
): MethodDecorator {
  return <T>(
    target: { uiActions: UiActions },
    propertyKey: string | symbol,
    descriptor: TypedPropertyDescriptor<T>,
  ): TypedPropertyDescriptor<T> => {
    const originalMethod = descriptor.value;

    if (!isFunction(originalMethod)) {
      throw new TypeError(
        `@WrapWithLoader() decorator can be applied only for methods.`,
      );
    }

    const wrapper = async function (...params: any[]): Promise<any> {
      const isEnableLoader = get(
        params[targetParamPos ?? 0],
        isEnableLoaderField,
        true,
      );

      if (!isEnableLoader) {
        // eslint-disable-next-line no-invalid-this
        return originalMethod.apply(this, params);
      }

      // eslint-disable-next-line no-invalid-this
      this.uiActions.enableLoader();
      // eslint-disable-next-line no-invalid-this
      if (isPreventLoaderCloseAfterRequestFinish) {
        this.uiActions.preventDisableLoaderAfterRequestFinish(true);
      }
      // use preventLoaderCloseWhenTimeout to avoid loader over 35s will be auto disabled.
      // eslint-disable-next-line no-invalid-this
      this.uiActions.preventLoaderCloseWhenTimeout(true);

      let res;
      try {
        // eslint-disable-next-line no-invalid-this
        res = await originalMethod.apply(this, params);
      } finally {
        // eslint-disable-next-line no-invalid-this
        this.uiActions.disableLoader();
        // eslint-disable-next-line no-invalid-this
        this.uiActions.preventLoaderCloseWhenTimeout(false);
        // eslint-disable-next-line no-invalid-this
        if (isPreventLoaderCloseAfterRequestFinish) {
          this.uiActions.preventDisableLoaderAfterRequestFinish(false);
        }
      }

      return res;
    };

    return {
      ...descriptor,
      value: wrapper as any,
    };
  };
}

export { wrapWithLoader };
